export default {
    "QYZC":[{"id":1,"name":'按行业办理','child':[
            {"id": 1, "names": "餐饮食品业",'content':['<span style="color:black !important;">经营场景：</span>餐厅、酒店、外卖、食堂、食品加工厂等',
                '<span style="color:black !important;">注册类型：</span>个体工商户、有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-办理食品经营许可证-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 2, "names": "商贸零售业",'content':['<span style="color:black !important;">经营场景：</span>百货、超市、专业连锁、物业经营、贸易等',
                '<span style="color:black !important;">注册类型：</span>有限公司、股份有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-根据不同业务需求办理相关资质（如进出口权、商品条形码等）-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            }, 
            {"id": 3, "names": "人力资源业",'content':['<span style="color:black !important;">经营场景：</span>求职招聘、劳动人事代理、就业指导、劳务派遣等',
                '<span style="color:black !important;">注册类型：</span>有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-根据不同业务需求办理人力资源行业资质（如人力资源服务许可证、劳务派遣许可证）-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 4, "names": "医疗药品业",'content':['<span style="color:black !important;">经营场景：</span>药房、医疗器械经营、药品经营、保健品经营等',
                '<span style="color:black !important;">注册类型：</span>有限公司、股份有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-办理医疗器械经营许可-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 5, "names": "信息技术业",'content':['<span style="color:black !important;">经营场景：</span>信息咨询、计算机制造、软件开发、印刷出版、新闻广播、通讯广告等',
                '<span style="color:black !important;">注册类型：</span>有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-根据不同业务需求办理互联网资质许可（如ICP、EDI、文网文等）-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 6, "names": "教育培训业",'content':['<span style="color:black !important;">经营场景：</span>幼儿园、早教机构、各类培训机构等',
                '<span style="color:black !important;">注册类型：</span>有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-办理办学许可证-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 7, "names": "建筑业",'content':['<span style="color:black !important;">经营场景：</span>土木工程、线路管道和设备安装、勘察设计、建筑安装/装饰等',
                '<span style="color:black !important;">注册类型：</span>有限公司、股份有限公司',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-根据不同业务需求办理建筑资质-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },
            {"id": 8, "names": "其他行业",'content':['<span style="color:black !important;">行业类型：</span>如文化体育业、交通运输业、金融业、房地产业、制造业、科技服务业、租赁服务业等',
                '<span style="color:black !important;">注册类型：</span>有限公司、个体工商户、合伙企业、个人独资等',
                '<span style="color:black !important;">注册流程：</span>工商核名-提交注册相关资料-取得营业执照-根据不同业务需求办理相关资质-开通银行基本账户-刻制印章-办理税务登记-开始申报纳税']
            },]},
        {"id":2,"name":'按企业办理','child':[
            {"id": 1, "names": "有限公司",'content':['<span style="color:black !important;">适用场景：</span>初创企业、中小型企业等',
                '<span style="color:black !important;">组织特点：</span>设立程序较简单，内部机构设置灵活；规模较小，不能公开发行股票。',
                '<span style="color:black !important;">财产责任：</span>每个股东以其所认缴的出资额为限对公司承担有限责任，公司法人以其全部资产对公司债务承担全部责任。']
            },
            {"id": 2, "names": "个体工商户",'content':['<span style="color:black !important;">适用场景：</span>餐馆、小卖部、奶茶店、外卖/电商卖家等。',
                '<span style="color:black !important;">组织特点：</span>登记手续简单、费用少、经营方式灵活、信用度及知名度较低。',
                '<span style="color:black !important;">财产责任：</span>个人经营的，以个人财产承担；家庭经营的，以家庭财产承担。']
            },
            {"id": 3, "names": "个人独资企业",'content':['<span style="color:black !important;">适用场景：</span>高利润企业、高收入群体。',
                '<span style="color:black !important;">组织特点：</span>免收企业所得税，架构简单，决策自主，注册资金随意。',
                '<span style="color:black !important;">财产责任：</span>个人出资，全部资产为投资人所有，对企业债务承担无限责任。']
            },
            {"id": 4, "names": "有限合伙企业",'content':['<span style="color:black !important;">适用场景：</span>多为投资、咨询、技术、知识产权类公司。',
                '<span style="color:black !important;">组织特点：</span>只缴纳合伙人的个人所得税，无需纳企业所得税。',
                '<span style="color:black !important;">财产责任：</span>由普通合伙人和有限合伙人组成，普通合伙人对合伙企业债务承担无限连带责任，有限合伙人以其认缴的出资额为限对合伙企业债务承担责任。']
            },
            {"id": 5, "names": "股份有限公司",'content':['<span style="color:black !important;">适用场景：</span>一般为成熟、大规模类型公司。',
                '<span style="color:black !important;">组织特点：</span>投资灵活，有效筹集和吸收社会资金，利于分散投资者风险。',
                '<span style="color:black !important;">财产责任：</span>公司资本为股份所组成，股东以其认购的股份为限对公司承担责任。']
            },
            {"id": 6, "names": "中外合资企业",'content':['<span style="color:black !important;">适用场景：</span>高新技术、能源材料、技术设备等经营范围。',
                '<span style="color:black !important;">组织特点：</span>资源共享，优势互补；包括外资利用中方企业网络及品牌顺利进入中国市场，减少各项财务支出，享受外商投资者优惠，降低经营成本。',
                '<span style="color:black !important;">财产责任：</span>合营各方按各自的出资比例共担风险、共负盈亏。']
            },
            {"id": 7, "names": "集团公司",'content':['<span style="color:black !important;">适用场景：</span>拥有众多生产、经营机构的大型公司。',
                '<span style="color:black !important;">组织特点：</span>便于资金统筹，减少资金成本，内部资源共享，企业形象强大，利于市场竞争。',
                '<span style="color:black !important;">财产责任：</span>母子公司一般各自独立负债，不存在企业集团的共同债务。特殊情况下，母公司才对子公司的债务负责（如母公司承诺了担保）。']
            },
            {"id": 8, "names": "其他公司类型",'content':['<span style="color:black !important;">公司类型：</span>其他包括外资企业、国有独资等。',
                '<span style="color:black !important;">设立程序：</span>不同公司类型登记条件、资料、流程、手续、资金等各不相同。']
            },
        ]}
    ],
    "PXtype":[
        {"id":"1","name":"财务培训"},
        {"id":"2","name":"税务培训"},
        {"id":"3","name":"管理培训"},
        {"id":"4","name":"其他培训"},
    ],
    "GCtype":[
        {"id":"1","name":"工程项目概算、预算、结算、竣工决算、工程招标底价、投标报价的编制或审核"},
        {"id":"2","name":"建设项目建议书、可行性研究与投资估算的编制、审核及项目经济评价"},
        {"id":"3","name":"招标、投标代理"},
        {"id":"4","name":"工程造价信息咨询"},
        {"id":"5","name":"工程造价有关的其他业务咨询"},
    ],
    "SJtype":[
        {"id":"1","name":"财务报表审计"},
        {"id":"2","name":"经济责任审计"},
        {"id":"3","name":"财务收支审计"},
        {"id":"4","name":"内部控制审计"},
        {"id":"5","name":"尽职调查审计"},
        {"id":"6","name":"竣工决算审计"},
        {"id":"7","name":"清产核资审计"},
        {"id":"8","name":"财务顾问服务"},
        {"id":"9","name":"其他专项审计服务"},
    ],
}